import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const LineColorIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 16 16" {...props}>
      <path
        fill="#33bb00"
        d="M8 .5c4.411 0 8 2.9 8 6.465c0 1.44-.563 2.746-1.723 3.991c-1.615 1.822-5.198 4.043-6.075 4.4c-.106.044-.346.144-.607.144a.77.77 0 0 1-.482-.154c-.356-.274-.284-.72-.256-.89l.106-.65c.039-.296.011-.391.006-.404c.014.038-.087-.019-.301-.063C2.821 12.84 0 10.156 0 6.965C0 3.401 3.589.5 8 .5M3.165 4.974c-.235 0-.43.19-.43.421v3.193c0 .23.195.42.43.42h1.627c.236 0 .43-.19.43-.42a.426.426 0 0 0-.43-.421H3.594V5.395a.426.426 0 0 0-.429-.42zm2.88 0c-.237 0-.43.19-.43.421v3.193c0 .23.193.42.428.42c.237 0 .43-.19.43-.42V5.395a.427.427 0 0 0-.428-.42zm3.913 0c-.237 0-.43.19-.43.421v1.978L7.85 5.145a.45.45 0 0 0-.338-.17a.42.42 0 0 0-.425.42v3.193c0 .23.19.42.427.42c.24 0 .43-.19.43-.42V6.62l1.665 2.22a.42.42 0 0 0 .348.167a.42.42 0 0 0 .43-.419V5.395a.43.43 0 0 0-.429-.42zm3.06 0h-1.627c-.238 0-.43.19-.43.421v3.193c0 .23.192.42.428.42h1.627c.238 0 .43-.19.43-.42a.424.424 0 0 0-.43-.421H11.82v-.754h1.197c.238 0 .43-.19.43-.42a.426.426 0 0 0-.43-.423H11.82v-.753h1.197a.425.425 0 0 0 .43-.422a.425.425 0 0 0-.428-.42z"
      ></path>
    </svg>
  );
};
export default LineColorIcon;
